import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { WhiskyDB } from "../../data/db";
import { Events } from "ionic-angular/util/events";
import { NavParams } from "ionic-angular/navigation/nav-params";
import { ViewController } from "ionic-angular/navigation/view-controller";

@Component({
  selector: "page-newWhiskySelect",
  templateUrl: "newWhiskySelect.html"
})
export class NewWhiskySelectPage {
  items: any[];
  allItems: any[];
  limit = 20;

  title = "";
  constructor(
    public navCtrl: NavController,
    private events: Events,
    private navParams: NavParams,
    private viewCtrl: ViewController
  ) {}

  ionViewWillEnter() {
    this.title = this.navParams.get("title");
    this.getItems(null);
  }

  getItems(ev: any) {
    let val = "";
    if (ev != null) {
      val = ev.target.value;
    }

    if (val && val.trim() != "") {
      console.log("Filter=" + val);
      if (this.title === "Distillery") {
        this.allItems = WhiskyDB.distilleries.filter(item => {
          return (
            item.Distillery.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            item.Region.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            item.SMWS.toLowerCase().indexOf(val.toLowerCase()) > -1
          );
        });
      } else if(this.title === "Bottler") {
        this.allItems = WhiskyDB.bottlers.filter(item => {
            return item.toLowerCase().indexOf(val.toLowerCase()) > -1;
        });
        //this.allItems.unshift("Official Distillery Bottling");
      }
    } else {
      // Reset items back to all of the items
      if(this.title === "Distillery")
        this.allItems = WhiskyDB.distilleries;
      else if (this.title === "Bottler") {
        this.allItems = WhiskyDB.bottlers;
        if(this.allItems[0] !== "Official Distillery Bottling")
          this.allItems.unshift("Official Distillery Bottling");
      }        
    }

    this.limit = 20;
    this.items = this.allItems.slice(
      0,
      Math.min(this.limit, this.allItems.length)
    );
  }
  dismiss()
  {
    this.viewCtrl.dismiss();
  }

  getName(item: any) {
    if(this.title === "Distillery")
      return item.Distillery;
    if(this.title === "Bottler")
      return item;
    return "";
  }
  doInfinite(event: any) {
    //console.log("doInfinite");
    // Get next chunk from all filtered & sorted items
    let prior = this.limit;
    this.limit = this.limit + 20;
    //console.log("get more items: " + this.limit);
    this.limit = Math.min(this.limit, this.allItems.length);
    let moreItems = this.allItems.slice(prior, this.limit);

    moreItems.forEach(i => {
      this.items.push(i);
    });

    event.complete();
  }

  selectItem(item: any) {
    console.log(item);
    if(this.title == "Distillery") {
      this.events.publish("select:distillery", item);
    } else if(this.title === "Bottler") {
      if(item === "Official Distillery Bottling")
        item = "";
      this.events.publish("select:bottler", item);      
    }
    this.dismiss();
//    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/newWhiskySelect/newWhiskySelect.ts